import Vue from "vue";
import store from "./store";
import vSelect from "vue-select"; // https://vue-select.org
import VuejsDialog from "vuejs-dialog"; // https://www.npmjs.com/package/vuejs-dialog
//import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import Snotify, { SnotifyPosition } from "vue-snotify"; // https://artemsky.github.io/vue-snotify/documentation/installation.html
import App from "./App.vue";
import router from "./router";
import Switcher from "./components/Switcher.vue";
import Loading from "./components/Loading.vue";
import ApiService from "./services/api.service";
import "vue-googlemaps/dist/vue-googlemaps.css";
import VueGoogleMaps from "vue-googlemaps";
import { TokenService } from "./services/storage.service";
import PosthogPlugin from "./plugins/posthog";
import posthog from "posthog-js";
const apiPort = window.location.hostname === "localhost" ? ":3001" : "";
const host = window.location.hostname === "localhost" ? "http://localhost" : "https://" + window.location.hostname;

import { library } from "@fortawesome/fontawesome-svg-core";
import {
	faFloppyDisk,
	faSearch,
	faFileCsv,
	faMobileAlt,
	faDesktop,
	faUser,
	faSignOutAlt,
	faExchangeAlt,
	faProjectDiagram,
	faGlobeAmericas,
	faKeyboard,
	faEye,
	faEyeSlash,
	faExternalLinkAlt,
	faBolt,
	faBinoculars,
	faUsersCog,
	faBell,
	faTrashAlt,
	faPauseCircle,
	faPause,
	faPlayCircle,
	faCirclePlus,
	faCircleMinus,
	faIndent,
	faDollarSign,
	faAlignLeft,
	faMapMarkerAlt,
	faBrain,
	faQuoteRight,
	faNewspaper,
	faMap,
	faPlaneDeparture,
	faImages,
	faShoppingBasket,
	faBriefcase,
	faCalendarCheck,
	faPortrait,
	faUtensils,
	faMountain,
	faBook,
	faFireAlt,
	faMicrophoneAlt,
	faStarHalfAlt,
	faPencilAlt,
	faHotel,
	faQuestionCircle,
	faAngleDoubleRight,
	faCopy,
	faVideo,
	faQuestion,
	faChartLine,
	faWarehouse,
	faWrench,
	faFileInvoiceDollar,
	faCreditCard,
	faTools,
	faFilePdf,
	faLink,
	faHighlighter,
	faCircleNodes,
	faPlay,
	faDownLeftAndUpRightToCenter,
	faMaximize,
	faMagnifyingGlass,
	faRoad,
	faCity,
	faUpload,
	faLightbulb,
	faUpRightAndDownLeftFromCenter,
	faTriangleExclamation,
	faHandPointUp,
	faGifts,
	faFolderOpen,
	faGear,
	faUpDown,
	faFileArrowUp,
	faArrowUp19,
	faImage,
	faListUl,
	faFileCirclePlus,
	faTable,
	faFont,
	faCheckSquare
} from "@fortawesome/free-solid-svg-icons";
import { faTwitter, faSearchengin } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Set the base URL of the API
ApiService.init(host + apiPort + "/api/");

// If token exists set header
if (TokenService.getToken()) {
	ApiService.setHeader();
	ApiService.mountInterceptor();
}

library.add(
	faRoad,
	faLightbulb,
	faUpload,
	faCity,
	faMaximize,
	faMagnifyingGlass,
	faHighlighter,
	faDownLeftAndUpRightToCenter,
	faPause,
	faLink,
	faGifts,
	faSearch,
	faCirclePlus,
	faCircleMinus,
	faFilePdf,
	faFloppyDisk,
	faTools,
	faFileCsv,
	faMobileAlt,
	faDesktop,
	faUser,
	faSignOutAlt,
	faExchangeAlt,
	faProjectDiagram,
	faGlobeAmericas,
	faKeyboard,
	faEye,
	faBolt,
	faExternalLinkAlt,
	faBinoculars,
	faUsersCog,
	faBell,
	faTrashAlt,
	faPauseCircle,
	faPlayCircle,
	faPlay,
	faIndent,
	faDollarSign,
	faAlignLeft,
	faMapMarkerAlt,
	faBrain,
	faQuoteRight,
	faNewspaper,
	faMap,
	faPlaneDeparture,
	faImages,
	faShoppingBasket,
	faBriefcase,
	faCalendarCheck,
	faPortrait,
	faUtensils,
	faMountain,
	faBook,
	faFireAlt,
	faMicrophoneAlt,
	faStarHalfAlt,
	faPencilAlt,
	faHotel,
	faQuestionCircle,
	faAngleDoubleRight,
	faCopy,
	faTwitter,
	faVideo,
	faQuestion,
	faSearchengin,
	faChartLine,
	faWarehouse,
	faWrench,
	faFileInvoiceDollar,
	faCreditCard,
	faEyeSlash,
	faCircleNodes,
	faUpRightAndDownLeftFromCenter,
	faTriangleExclamation,
	faHandPointUp,
	faFolderOpen,
	faGear,
	faUpDown,
	faFileArrowUp,
	faArrowUp19,
	faImage,
	faListUl,
	faFileCirclePlus,
	faTable,
	faFont,
	faCheckSquare
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.component("v-select", vSelect);
Vue.component("switcher", Switcher);
Vue.component("loading", Loading);

Vue.use(VueGoogleMaps, {
	load: {
		// Google API key
		apiKey: "AIzaSyCvRldIeN4VozH0fllJz8LQUVdUu7JJ7cM",
		// Enable more Google Maps libraries here
		libraries: ["places"],
		// Use new renderer
		useBetaRenderer: false,
	},
});

Vue.use(VuejsDialog, {
	html: true,
	okText: "Continue",
	cancelText: "Cancel",
	animation: "bounce",
});

Vue.use(Snotify, {
	toast: {
		timeout: 7500,
		showProgressBar: true,
		closeOnClick: true,
		pauseOnHover: true,
		position: SnotifyPosition.rightTop,
		allowHtml: true,
	},
});

Vue.directive("scroll", {
	inserted: function(el, binding) {
		let f = function(evt) {
			if (binding.value(evt, el)) {
				window.removeEventListener("scroll", f);
			}
		};
		window.addEventListener("scroll", f);
	},
});

Vue.config.productionTip = false;

if (window.location.hostname === "app.rankcaddy.io" || window.location.hostname === "dev.rankcaddy.io") {
	Vue.use(PosthogPlugin);
	router.afterEach(() => {
		Vue.nextTick(() => {
			posthog.capture("$pageview");
		});
	});
}

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
